import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'csl-skeleton',
  standalone: true,
  template: '<div class="bg-gray-200 animate-pulse min-h-3 h-full"></div>',
  styleUrl: './skeleton.component.css',
  host: {
    class: 'overflow-hidden',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {}
